//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React, {useState} from "react";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import CloseableDialog from "eai-configurator-ui/components/configuration/dialog/CloseableDialog";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Paper from "@material-ui/core/Paper";
import "../main.css";
import CustomizeColumnsTable from "src/components/loader/table/CustomizeColumnsTable";
import * as Config from "eai-configurator-ui/components/configuration/utils/ConfigurationRegistry";

function TabPanel(props) {
  const {children, value, index, ...other} = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      <p/>
      {value === index && children}
    </div>
  );
}

const CustomizeColumnsDialog = ({path, moduleName, handleClose, open, modules}) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [initialModuleColumnsConfig, setInitialModuleColumnsConfig] = useState(
    null
  );

  const moduleColumnsPath = path + ":moduleColumns";
  React.useEffect(() => {
    // Reset tab index
    setTabIndex(0);
    if (moduleName) {
      setInitialModuleColumnsConfig(Config.fromPath(moduleColumnsPath));
    }
  }, [moduleName]);

  const handleCloseClick = () => {
    // Revert changes (do not save them if the user clicks the close button)
    Config.updateChild(
      Config.fromPath(path),
      Config.fromPath(moduleColumnsPath),
      initialModuleColumnsConfig
    );

    handleClose();
  };

  const handleSaveClick = () => {
    handleClose();
  };

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  // No module, nothing is rendered
  if (!moduleName) {
    console.log("Module name was not provided");
    return null;
  }

  const useModule = modules.find(m => m.moduleName === moduleName);
  if (!useModule) {
    console.log("Module " + moduleName + " was not found");
    return null;
  }

  const fieldsIndex = 0
  const udfIndex = 1
  let uniqueUdfIndex = 1
  let codeIndex = 1
  if (useModule.supportUdfs) {
    uniqueUdfIndex++;
    codeIndex++;
  }
  if (useModule.supportUniqueUdfs) {
    codeIndex++;
  }

  return (
    <CloseableDialog
      title={"Customize Columns: " + moduleName}
      open={open}
      maxWidth="md"
      fullWidth
      handleClose={handleCloseClick}
    >
      <DialogContent dividers>
        <div>
          <Paper square>
            <Tabs
              value={tabIndex}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              aria-label="disabled tabs example"
            >
              <Tab label="Fields"/>
              {useModule.supportUdfs &&
                <Tab label="UDFs"/>}
              {useModule.supportUniqueUdfs &&
                <Tab label="Index UDFs"/>}
              {useModule.supportCodes &&
                <Tab label="Codes"/>}
            </Tabs>
          </Paper>

          <TabPanel value={tabIndex} index={fieldsIndex}>
            <CustomizeColumnsTable
              module={moduleName}
              path={path}
              type={"fields"}
              loadType={"fields"}
              loadAllByDefault={true}
            />
          </TabPanel>

          {useModule.supportUdfs &&
            <TabPanel value={tabIndex} index={udfIndex}>
              <CustomizeColumnsTable module={moduleName} path={path} type={"udfs"} loadType={"udfs"} loadAllByDefault={true}/>
            </TabPanel>}

          {useModule.supportUniqueUdfs &&
            <TabPanel value={tabIndex} index={uniqueUdfIndex}>
              <CustomizeColumnsTable module={moduleName} path={path} type={"uniqueUdfs"} loadType={"udfs"} loadAllByDefault={false}/>
            </TabPanel>}

          {useModule.supportCodes &&
            <TabPanel value={tabIndex} index={codeIndex}>
              <CustomizeColumnsTable module={moduleName} path={path} type={"codes"} loadType={"codes"} loadAllByDefault={true}/>
            </TabPanel>}
        </div>
      </DialogContent>
      <DialogActions>
        <Button color="primary" variant={"contained"} onClick={handleSaveClick}>
          Save
        </Button>
      </DialogActions>
    </CloseableDialog>
  );
};
export default CustomizeColumnsDialog;
